import { create } from "zustand";

import { outputModeOptions, processingModeOptions } from "../constants";

const defaultState = {
  formData: {
    processing_mode: processingModeOptions[0].value,
    output_mode: outputModeOptions[0].value,
    force_text_processing: false,
  },
  fileUrl: "",
  fileData: {},
  fileName: "",
  fileBlob: {},
  extractedText: "",
  isLoading: false,
  tabView: false,
  isSubmitted: false,
  activeKey: null,
};

const STORE_VARIABLES = defaultState;

const useSettingsStore = create((setState, getState) => ({
  ...STORE_VARIABLES,
  updateSettingsState: (entireState) => {
    const existingState = { ...getState() };
    const newState = { ...existingState, ...entireState };
    setState({ ...newState });
  },
  setDefaultSettingsState: () => {
    setState(defaultState);
  },
}));

export { useSettingsStore };
